import type React from "react";
import type { TowerShipment } from "../../types/controlTower";

// Utilidades compartidas por las pantallas de la Torre.

// El recorrido del día arranca a las 6:00: una visita de madrugada es del
// recorrido de la noche anterior (no cuenta como actividad ni como parada de hoy).
export const ROUTE_DAY_START_HOUR = 6;

// Envío con coordenadas utilizables en el mapa.
export function hasCoordinates(
  shipment: TowerShipment | null | undefined,
): shipment is TowerShipment & { latitude: number; longitude: number } {
  return Boolean(
    shipment &&
      shipment.latitude !== null &&
      shipment.longitude !== null &&
      Number.isFinite(shipment.latitude) &&
      Number.isFinite(shipment.longitude),
  );
}

const argentinaDate = new Intl.DateTimeFormat("en-CA", {
  timeZone: "America/Argentina/Buenos_Aires",
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
});

// Fecha "YYYY-MM-DD" en Argentina, sin depender de la zona horaria de la PC.
export function argentinaDateKey(nowMs: number = Date.now()): string {
  const parts = argentinaDate.formatToParts(new Date(nowMs));
  const get = (type: string) => parts.find((part) => part.type === type)?.value;
  return `${get("year")}-${get("month")}-${get("day")}`;
}

// Enter o espacio sobre un elemento con role="button" hacen lo mismo que el
// clic. Si el foco está en un botón o enlace de adentro, actúa ese control.
export const activateOnKey = (action: () => void) => (event: React.KeyboardEvent) => {
  if (event.target !== event.currentTarget) return;
  if (event.key === "Enter" || event.key === " ") {
    event.preventDefault();
    action();
  }
};
